import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { PendingActionEffects } from './pending-action.effects';
import { UserInfoActions } from '../user-info/user-info.actions';
import { MessagesActions } from '../messages/messages.actions';
import { WindowStateActions } from '../window/window.actions';
import { ChatAdminActions } from '../chat-admin/chat-admin.actions';
import { PendingActionType } from '../../types/enum';

export const initialState: Readonly<PendingAction> = {
  type: PendingActionType.empty,
  parameters: null,
};

export const pendingActionFeature = createFeature({
  name: 'pendingAction',
  reducer: createReducer(
    initialState,
    on(
      MessagesActions.callDialogApi,
      ChatAdminActions.escalate,
      WindowStateActions.requestToOpenWindow,
      () => {
        return { type: PendingActionType.empty, parameters: null };
      }
    ),
    on(
      UserInfoActions.signIn,
      WindowStateActions.endSessionToStartNew,
      (state, { pendingAction }) => {
        return pendingAction;
      }
    )
  ),
});

export const { selectPendingActionState } = pendingActionFeature;

export function providePendingActionFeature() {
  return makeEnvironmentProviders([
    provideState(pendingActionFeature),
    provideEffects(PendingActionEffects),
  ]);
}
